import React from 'react';
import PropTypes from 'prop-types';
import MapSenate from '../Map/Senate';
import { Map } from './styles';
import { Button, Title } from '../InterestingDistricts/styles';
import styled, { css } from 'react-emotion';

const SummaryMapTitle = styled(Title)`
	color: #1B69BF;
	font-size: 1.125rem;
	text-align: left;
	float: left;
`

const SummaryMap = styled(Map)`
	float: none;
	max-width: 315px;
	width: 300px;
	margin-left: auto;
	margin-right: auto;
	
	svg {
		@media (max-width: 480px) {
			display: block;
			width: 70%;
			margin-left: auto;
			margin-right: auto;
		}
		@media (max-width: 515px) {
			max-height: 132px;
			width: 250px;
		}
	}

	@media (max-width: 480px) {
		margin-left: auto;
		margin-right: auto;
		width: 100%;
		float: none;
	}
`

const summaryButton = css`
	float: right;
	text-align: right;
	margin: 0;
	@media (max-width: 1090px) {
		display: none;
	}
`

const ButtonMobileDevice = styled.div`
	position: absolute;
	bottom: 16px;
	left: 0;
	right: 0;
	@media (min-width: 1091px) {
		display: none;
	}
`

export default class WidgetSummaryMap extends React.PureComponent {
	onClick = (id) => {
		window.top.location.href = `${this.props.link}#/obvod/${id}`;
	}

	render() {
		const linkToFirstRound = `${this.props.link}#/round1`
		return <>
			<SummaryMapTitle>Senátní volby - Výsledky ve 2. kole</SummaryMapTitle>
			<Button reverse className={summaryButton} href={linkToFirstRound}>
				Výsledky 1. kola
			</Button>
			<SummaryMap>
				<MapSenate
					districts={this.props.districts}
					leaders={this.props.leaders}
					mapProps={{ viewBox: '0 0 420 237', height: '177', overflow: 'hidden' }}
					onClick={this.onClick}
					roundIndex={1}
				/>
			</SummaryMap>
			<ButtonMobileDevice>
				<Button reverse href={linkToFirstRound}>
					Výsledky 1. kola
				</Button>
			</ButtonMobileDevice>
		</>;
	}
}

WidgetSummaryMap.propTypes = {
	meta: PropTypes.shape({
		turnout: PropTypes.number.isRequired
	}).isRequired,
	link: PropTypes.string.isRequired,
	districts: PropTypes.arrayOf(PropTypes.number).isRequired,
	leaders: PropTypes.object.isRequired
}
